import claimService from '@/services/claim.service'
import postponeService from '@/services/postpone.service'

const state = {
    logins: [],
    tours: [],
    hotels: [],
    filters: [],
    postponedClaims: [],
    loading: false,
    restoring: false
}

const getters = {
    
}

const mutations = {
    clearResult ({ commit }) {
        commit('setPostponedClaims', []);
    },
    setLogins(state, logins = []) {
        state.logins = logins;
    },
    setTours(state, tours = []) {
        state.tours = tours;
    },
    setHotels(state, hotels = []) {
        state.hotels = hotels;
    },
    setFilters(state, filters = []) {
        state.filters = filters;
    },
    setPostponedClaims(state, postponedClaims = []) {
        state.postponedClaims = postponedClaims;
    },
    flushPostponedClaims(state) {
        state.postponedClaims = [];
    },
    deletePostponedClaim(state, id) {
        state.postponedClaims = state.postponedClaims.filter((claim) => claim.postpone_id !== id );
    },
    setLoading(state, loading = false) {
        state.loading = loading;
    },
    setRestoring(state, restoring = false) {
        state.restoring = restoring;
    }
}

const actions = {
    getLogins ({ commit }) {
        claimService.getLogins().then(response => {
            commit('setLogins', response);
        }).catch(() => {
        })
    },
    getTours ({ commit }) {
        claimService.getTours().then(response => {
            commit('setTours', response);
        }).catch(() => {
            
        })
    },
    getHotels ({ commit }) {
        claimService.getHotels().then(response => {
            commit('setHotels', response);
        }).catch(() => {
            
        })
    },
    getFilters ({ commit }) {
        postponeService.getFilters().then(response => {
            commit('setFilters', response);
        }).catch(() => {
            
        })
    },
    getPostponedClaims ({ commit }, params) {
        commit('setLoading', true);
        commit('flushPostponedClaims');
        
        postponeService.getPostponedClaims(params).then(response => {
            commit('setPostponedClaims', response);
            commit('setLoading', false);
        }).catch(() => {
            commit('setLoading', false);
        })
    },
    restoreClaim ({ commit }, params) {
        commit('setRestoring', true);
        return new Promise((resolve, reject) => {
            postponeService.restoreClaim(params).then(response => {
                commit('deletePostponedClaim', params.claim_id);
                commit('setRestoring', false);
                resolve(response);
            }).catch((error) => {
                commit('setRestoring', false);
                reject(error);
            })
        });
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}